import { inject, Injectable } from "@angular/core";
import { Amplify } from "aws-amplify";
import { environment } from "../../../environments/environment";
import {AuthSession, ConfirmResetPasswordInput, ConfirmSignInOutput, FetchAuthSessionOptions, GetCurrentUserOutput, JWT, ResetPasswordInput, ResetPasswordOutput, SignInInput, SignInOutput, confirmResetPassword, confirmSignIn, fetchAuthSession, getCurrentUser, resetPassword, signIn, signOut} from "aws-amplify/auth";
import { Hub } from 'aws-amplify/utils';
import { BehaviorSubject, from, Observable, tap } from "rxjs";
import { Store } from "@ngrx/store";
import { loggedUserActions } from "../../store/logged_user/logged_user.actions";
import { ToastrService } from "ngx-toastr";
import { User } from "../../models/user.model";
import { Router } from "@angular/router";


@Injectable({
    providedIn: 'root'
})
export class CognitoService {
    private router = inject(Router)

    public isUserLogged = false;
    idToken: JWT | null = null;
    accessToken: JWT | null = null;
    authEvents: BehaviorSubject<{userLogged: boolean; extras?: any}> = new BehaviorSubject<{userLogged: boolean; extras?: any}>({userLogged: false, extras: 'no-login'});
    userData: GetCurrentUserOutput | null = null;

    private store = inject(Store);
    private toastr = inject(ToastrService);

    constructor() {
        Amplify.configure({
            Auth: {
                Cognito: environment.cognito
            }
        })
        
        Hub.listen('auth', data => {
            switch(data.payload.event) {
                case "signedIn":
                    this.isUserLogged = true;
                    this.fetchUserInfo();
                    break;
                case "signedOut":
                    this.isUserLogged = false;
                    break;
            }
        })
        this.fetchUserInfo();
    }

    fetchUserInfo(refresh: boolean = false): void {
        fetchAuthSession({forceRefresh: refresh}).then((data) => {
            this.idToken = data.tokens?.idToken || null;
            this.accessToken = data.tokens?.accessToken || null;
            // console.log(this.accessToken?.toString()) //! DEBUG ACCESS TOKEN

            this.isUserLogged = !!this.idToken && !!this.accessToken;

            if(this.isUserLogged){
                getCurrentUser().then((data) => {
                    this.userData = data;
                    this.authEvents.next({userLogged: this.isUserLogged, extras: {email: data.signInDetails?.loginId || "", user_id: data.userId || ""}});
                    this.store.dispatch(loggedUserActions.getLoggedUser({userId: this.accessToken!.payload.sub!}));
                });
            }
            else{
                this.userData = null;
                this.authEvents.next({userLogged: this.isUserLogged});
            }
        });
    }

    public signIn(signInInput:SignInInput) : Promise<SignInOutput> {
        return signIn(signInInput);
    }

    public getUser() : Promise<GetCurrentUserOutput> {
        return getCurrentUser();
    }

    public signOut() : Promise<void> {
        return signOut();
    }

    public confirmSignInWithNewPassword(newPassword: string): Promise<ConfirmSignInOutput> {
        return confirmSignIn({
            challengeResponse: newPassword,
        });
    }

    public refreshToken(): Promise<AuthSession> {
        return fetchAuthSession();
    }

    public resetPassword(resetPswdInput: ResetPasswordInput): Promise<ResetPasswordOutput> {
        return resetPassword(resetPswdInput);
    }

    public resetPasswordNextSteps(resetPswdOutput: ResetPasswordOutput) {
        const {nextStep} = resetPswdOutput;
        switch (nextStep.resetPasswordStep) {
            case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
                // const codeDeliveryDetails = nextStep.codeDeliveryDetails;
                // console.log(
                //     `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
                // );
                this.toastr.success('Codice di conferma inviato via e-mail', '', {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                })
                break;
            case 'DONE':
                console.log('Successfully reset password.');
                break;
        }
    }

    public confirmResetPassword(confirmResetPswdInput: ConfirmResetPasswordInput): Promise<any> {
        return confirmResetPassword(confirmResetPswdInput);
    }

    public checkUserAdmin(user: User) {
        if(user.role !== 'ADMIN') {
            this.router.navigate(['/bollette/estrazione-dati']);
        }
    }
}